import $ from 'jquery';

export function initManagerScan() {

    $(".manager-scan-report .btn-mail-manager-report").on("click", function (e) {
        e.preventDefault();
        var $this = $(this);

        $this.addClass("disabled").attr("disabled", "disabled");

        $.ajax({
            url: $this.attr("href"), method: "POST", data: {
                "scatterplot": $<HTMLFormElement>(".manager-scan-report .managerScanChart").get(0)?.toDataURL()
            }, dataType: "json", success: function (data) {

                if (typeof data.success != 'undefined' && data.success) {
                    $this.remove();
                    $(".manager-scan-report .mail-result .feedback").removeClass("d-none");
                } else {
                    $this.removeClass("disabled").attr("disabled");
                    $(".manager-scan-report .mail-result .error").removeClass("d-none");
                }

            }
        });

    });

}
